/* eslint-disable */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import * as Urql from 'urql';

import type * as Types from '../../../../../../generated/graphql/types';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CouponDataFragment = { __typename?: 'Coupon' } & Pick<
  Types.Coupon,
  'code' | 'isPercentage' | 'minPrice' | 'value' | 'expirationDate'
>;

export type HighlightedCouponQueryVariables = Types.Exact<{
  platform: Types.Platform;
  market: Types.Market;
  userSegments?: Types.InputMaybe<Types.Scalars['Map']['input']>;
}>;

export type HighlightedCouponQuery = { __typename?: 'Query' } & {
  thresholdHighlightedCoupons: Types.Maybe<
    { __typename?: 'ThresholdHighlightedCoupons' } & Pick<
      Types.ThresholdHighlightedCoupons,
      'endDate' | 'startDate' | 'label' | 'title' | 'description'
    > & {
        coupons: Types.Maybe<
          Array<
            { __typename?: 'Coupon' } & Pick<
              Types.Coupon,
              'code' | 'isPercentage' | 'minPrice' | 'value' | 'expirationDate'
            >
          >
        >;
      }
  >;
};

export const CouponDataFragmentDoc = /*#__PURE__*/ `
    fragment CouponData on Coupon {
  code
  isPercentage
  minPrice
  value
  expirationDate
}
    `;
export const HighlightedCouponDocument = /*#__PURE__*/ `
    query HighlightedCoupon($platform: Platform!, $market: Market!, $userSegments: Map) {
  thresholdHighlightedCoupons(
    platform: $platform
    market: $market
    channel: WEB
    userSegments: $userSegments
  ) {
    coupons {
      ...CouponData
    }
    endDate
    startDate
    label
    title
    description
  }
}
    ${CouponDataFragmentDoc}`;

export function useHighlightedCouponQuery(
  options: Omit<Urql.UseQueryArgs<HighlightedCouponQueryVariables>, 'query'>,
) {
  return Urql.useQuery<HighlightedCouponQuery, HighlightedCouponQueryVariables>(
    { query: HighlightedCouponDocument, ...options },
  );
}
